import { Vector2 } from '@math.gl/core';
import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import { ICrossSectionVertex } from '../shared/CrossSectionWindow';

import Konva from 'konva';

function drawPoint(opts: {
    id: string;
    name: string;
    point: Vector2;
    color: number[];
    visible: boolean;
    csCanvas: CrossSectionCanvas;
    onClickCallback: (point: ICrossSectionVertex, x: number, y: number) => void;
}) {
    let visible = opts.visible;

    const x = opts.csCanvas.metersToScreenCoordsX(opts.point[0]);
    const y = opts.csCanvas.metersToScreenCoordsY(opts.point[1]);
    const r = 3;
    const y_offset = 0;

    if (x > opts.csCanvas.width - opts.csCanvas.canvasOptions.side_margin / 2 || x < opts.csCanvas.canvasOptions.side_margin / 2) {
        visible = false;
    }
    if (y < opts.csCanvas.canvasOptions.top_margin || y > opts.csCanvas.height - opts.csCanvas.canvasOptions.bottom_margin) {
        visible = false;
    }

    const colorString: string = 'rgb(' + opts.color.join(',') + ')';

    const pointCircle = new Konva.Circle({
        visible: visible,
        name: 'pointcloud_' + opts.id,
        x: x,
        y: y - r + y_offset,
        stroke: 'rgb(0,0,0)', //colorString,
        fill: colorString,
        strokeWidth: 0.5,
        radius: r,
    });

    pointCircle.on('click tap', () => {
        // Empty for now
    });

    pointCircle.on('mouseover', function () {
        const text = `${opts.name}\n${opts.point[1].toFixed(3)} m`;
        showTooltip(text, x, y, r, y_offset, false, opts.csCanvas);
    });

    pointCircle.on('mouseout', () => opts.csCanvas.clearHoverTooltips());

    opts.csCanvas.contentLayer.add(pointCircle);

    return [pointCircle];
}

const showTooltip = (filename: string, x: number, y: number, r: number, y_offset: number, showProps: boolean, csCanvas: CrossSectionCanvas) => {
    const size = r * 2 + 4;
    const t: string[] = [filename].filter(Boolean);

    const bbRect = new Konva.Rect({
        x: x - (size - 1) / 2,
        y: y - (size - 1) / 2 - r + y_offset,
        width: size,
        height: size,
        stroke: 'gray',
        strokeWidth: 1,
        listening: false,
    });

    csCanvas.tooltipLayer.add(bbRect);
    csCanvas.drawTooltip(x, y - 4 - r * 2 + y_offset - 10, t.join('\n'), !!showProps);
    csCanvas.drawSnapCursor(true, x, y - r + y_offset);
};

export const CrossSectionPoint = {
    drawPoint,
};
